import { createContext, useContext } from "react";

export interface FilteredItem {
  id: string;
  label: string;
}

export interface IItemNavigatorProps {
  currentId: string | undefined;
  buildPath: (id: string) => string;
}

const FilteredItemIdsContext = createContext<string>("");

export const FilteredItemIdsProvider = FilteredItemIdsContext.Provider;

/** Returns the current navKey from context */
export const useNavKey = () => useContext(FilteredItemIdsContext);

// Lightweight store to avoid serializing navItems into location.state
const MAX_ENTRIES = 50;
const _store = new Map<string, FilteredItem[]>();

export const navStore = {
  set(items: FilteredItem[]): string {
    const key =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2);
    _store.set(key, items);
    if (_store.size > MAX_ENTRIES) {
      const first = _store.keys().next().value;
      if (first) _store.delete(first);
    }
    return key;
  },
  get(key: string): FilteredItem[] | null {
    return _store.get(key) ?? null;
  },
  touch(key: string): void {
    const items = _store.get(key);
    if (items !== undefined) {
      _store.delete(key);
      _store.set(key, items);
    }
  },
  delete(key: string): void {
    _store.delete(key);
  },
};
